<template>
  <!-- 使用 van-popup 从底部弹出 -->
  <van-popup v-model="open" position="bottom" closeable :style="{ height: '80%' }" round @closed="cancel">
    <div class="search-popup">
      <div class="header">
        <h3 class="title">{{ title }}</h3>
      </div>

      <van-form ref="form" :model="form" :rules="rules" @submit="submitForm" class="form-container">
        <!-- 图片上传 -->
        <van-field label="图片" name="src" required>
          <template #input>
            <image-upload v-model="form.url" :isShowTip="true" :limit="1" />
          </template>
        </van-field>

        <!-- 类型选择 -->
        <van-field
          label="类型"
          placeholder="请选择类型(最多选择两个)"
          readonly
          is-link
          @click="showTypePicker = true"
          :value="selectedTypeNames"
        />

        <!-- 类型逻辑（多选时显示） -->
        <van-field v-if="form.tags.length > 1" label="类型逻辑">
          <template #input>
            <van-radio-group v-model="form.tagLogic" direction="horizontal">
              <van-radio :name="0">必须同时满足</van-radio>
              <van-radio :name="1">满足任意一个</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 提交按钮 -->
        <div class="footer">
          <van-button block type="primary" native-type="submit">查 询</van-button>
          <van-button block style="margin-top: 10px" @click="cancel">取 消</van-button>
        </div>
      </van-form>

      <!-- 类型选择 Picker -->
      <van-popup v-model="showTypePicker" position="bottom">
        <van-checkbox-group v-model="form.tags" @change="onCheckboxChange" >
          <van-cell-group style="padding: 20px;">
            <van-cell
              v-for="(item, index) in typeList"
              clickable
              :key="index"
              :title="item.type"
              @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
          <div style="padding: 16px;">
            <van-button block type="primary" @click="showTypePicker = false">确认</van-button>
          </div>
        </van-checkbox-group>
      </van-popup>
    </div>
  </van-popup>
</template>

<script>
import { imageLibrarySearch } from "@/api/imageLibrary";
import { imageTypeList } from "@/api/imageType";

export default {
  data() {
    return {
      title: "查询",
      open: false,
      showTypePicker: false,
      form: {
        platForm: null,
        url: '',
        tags: [],      // 选中的类型 id 数组
        tagLogic: null
      },
      rules: {
        src: [{ required: true, message: '请上传图片', trigger: 'change' }],
        tags: [{ required: true, message: '请选择类型', trigger: 'change' }]
      },
      typeList: []
    };
  },
  computed: {
    // 显示已选类型名称
    selectedTypeNames() {
      return this.typeList
        .filter(item => this.form.tags.includes(item.id))
        .map(item => item.type)
        .join('、') || '';
    }
  },
  methods: {
    addCreateForm(platForm) {
      this.reset();
      this.open = true;
      this.form.platForm = platForm;
      this.getTypeList();
    },
    getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.form.platForm,
      }).then((response) => {
        const result = response.data.data;
        this.typeList = result.list || [];
      });
    },
    reset() {
      this.form = {
        platForm: null,
        url: '',
        tags: [],
        tagLogic: null
      };
    },
    toggle(index) {
      const checkbox = this.$refs.checkboxes[index];
      if (!checkbox.checked && this.form.tags.length >= 2) {
        this.$toast('最多只能选择2个类型！');
      } else {
        checkbox.toggle();
      }
    },
    onCheckboxChange(values) {
      if (values.length > 2) {
        this.$toast('最多只能选择2个类型！');
        // 自动调整为前两个选中的值
        this.form.tags = values.slice(0, 2);
      }
    },
    submitForm() {
          const data = {
            platForm: this.form.platForm,
            url: this.form.url,
            tags: this.form.tags.join(','),
            tag_logic: this.form.tagLogic
          };

          imageLibrarySearch(data).then(response => {
            this.open = false;
            if (response.data.code === 200) {
              const result = JSON.parse(response.data.data).result;
              result.forEach(e => {
                e.list = JSON.parse(e.brief);
              });
              console.log(result);
              this.$toast.success("查询成功");
              this.$emit('ok', result);
            } else {
              this.$toast.fail(response.data.msg);
            }
          }).catch(() => {
            this.$toast.fail('查询失败');
          });
    },
    cancel() {
      this.reset();
      this.open = false;
    }
  }
};
</script>

<style scoped>
.search-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
}

.header {
  padding: 16px;
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.header .title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.form-container {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  background-color: #fff;
}

/* 减小字段间距 */
.van-cell {
  padding: 8px 0;
  font-size: 14px;
}

.van-cell::after {
  left: 0;
}

.van-field__label {
  width: 90px !important;
  color: #333;
  font-weight: 500;
}

.van-radio {
  font-size: 14px;
  margin-right: 16px;
}

.footer {
  padding: 16px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}
.van-cell{
    padding: 8px 0;
    font-size: 12px;
}
.van-cell--required::before {
    position: absolute;
    left: 26px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}
</style>